/** @format */

import React from "react";

type CardBoxInfo = {
  number: string;
  title: string;
  summary: string;
};

const CardBox = ({ number, title, summary }: CardBoxInfo) => {
  return (
    <div className="flex flex-col md:w-[230px] md:px-0 px-2">
      <p className="services-number">{number}</p>
      <h3 className="font-bold text-[20px] text-[#121212] leading-[27px] tracking-[-0.02em] mb-[8px]">
        {title}
      </h3>
      <p className=" font-normal text-[18px] text-[#000000] leading-[25px] tracking-[-0.02em]">
        {summary}
      </p>
    </div>
  );
};

export default CardBox;
